"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canvasObject2cursorType = void 0;
var canvasObject2cursorType = function (value, mode) {
    switch (mode) {
        case 'readonly':
            return 'default';
        case 'auto-segmentation':
            if (value === undefined ||
                value === 'background' ||
                value.type !== 'paint')
                return 'crosshair';
            else
                return 'pointer';
        case 'rectbox':
            if (value === undefined || value === 'background')
                return 'crosshair';
            switch (value.type) {
                case 'point':
                    switch (value.location) {
                        case 'e':
                        case 'w':
                            return 'ew-resize';
                        case 'n':
                        case 's':
                            return 'ns-resize';
                        case 'nw':
                        case 'se':
                            return 'nwse-resize';
                        case 'ne':
                        case 'sw':
                            return 'nesw-resize';
                        default:
                            return 'default';
                    }
                case 'edge':
                    return 'move';
                case 'face':
                default:
                    return 'crosshair';
            }
    }
};
exports.canvasObject2cursorType = canvasObject2cursorType;
